import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { OWNER_ACCOUNT_DETAILS_API } from "../apiRoutes";

interface UseGetOwnerAccountDtlByOwnershipIdProps {
  id: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOwnerAccountDtlByOwnershipId = async (communityId: string, id: string) =>
  await axiosAuth.get(`${OWNER_ACCOUNT_DETAILS_API}/community/${communityId}/user/${id}`);

const useGetOwnerAccountDtlByOwnershipId = ({
  id,
  communityId,
  queryParams,
}: UseGetOwnerAccountDtlByOwnershipIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["ownerAccountDtl", id],
    queryFn: () => getOwnerAccountDtlByOwnershipId(communityId, id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetOwnerAccountDtlByOwnershipId;
